"use client";

import { ExpandingMenuProvider } from "./expanding-menu.context";
import type { ExpandingMenuProps } from "./types/expanding-menu.types";

import { ExpandingMenuTrigger } from "./expanding-menu-trigger";
import { ExpandingMenuContent } from "./expanding-menu-content";
import { ExpandingMenuItem } from "./expanding-menu-item";
import { ExpandingMenuLink } from "./expanding-menu-link";

type ExpandingMenuComponents = {
  Trigger: typeof ExpandingMenuTrigger;
  Content: typeof ExpandingMenuContent;
  Item: typeof ExpandingMenuItem;
  Link: typeof ExpandingMenuLink;
};

export const ExpandingMenu: React.FC<ExpandingMenuProps> & ExpandingMenuComponents = (props) => {
  const { children, className, ...rest } = props;

  return (
    <ExpandingMenuProvider className={className} {...rest}>
      {children}
    </ExpandingMenuProvider>
  );
};

ExpandingMenu.Trigger = ExpandingMenuTrigger;
ExpandingMenu.Content = ExpandingMenuContent;
ExpandingMenu.Item = ExpandingMenuItem;
ExpandingMenu.Link = ExpandingMenuLink;

ExpandingMenu.displayName = "ExpandingMenu";
